var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StreamCtrl',{attrs:{"name":_vm.name,"rtmp-server":_vm.rtmpServer,"stream-key":_vm.streamKey,"fullname":_vm.fullname},on:{"on-close":_vm.onClose,"on-end-stream":_vm.onEndStream}})
}
var staticRenderFns = []

export { render, staticRenderFns }